import React from "react";
import { Link } from "react-router-dom";
import { Home, ChevronRight } from "lucide-react";

/**
 * Breadcrumbs — reusable navegación contextual
 *
 * Props:
 *  items: [{ label: string, to?: string }]
 *  variant: 'dark' (default for dark interior pages) | 'light'
 */
export const Breadcrumbs = ({ items = [], variant = "dark", className = "" }) => {
  const isDark = variant === "dark";
  const baseColor = isDark ? "text-slate-400" : "text-slate-600";
  const activeColor = isDark ? "text-[#CCD500]" : "text-[#384451]";
  const hoverColor = isDark ? "hover:text-white" : "hover:text-[#384451]";
  const sep = isDark ? "text-slate-600" : "text-slate-400";

  return (
    <nav aria-label="Breadcrumb" className={`text-sm ${className}`} data-testid="breadcrumbs">
      <ol className="flex items-center flex-wrap gap-1.5">
        <li>
          <Link to="/" className={`inline-flex items-center gap-1 ${baseColor} ${hoverColor} transition-colors`} data-testid="breadcrumb-home">
            <Home className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Inicio</span>
          </Link>
        </li>
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <React.Fragment key={`${item.label}-${i}`}>
              <ChevronRight className={`w-3.5 h-3.5 ${sep}`} />
              <li>
                {last || !item.to ? (
                  <span className={`font-semibold ${activeColor}`} data-testid={`breadcrumb-current`}>{item.label}</span>
                ) : (
                  <Link to={item.to} className={`${baseColor} ${hoverColor} transition-colors`} data-testid={`breadcrumb-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
                    {item.label}
                  </Link>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
